const mapStateToProps = (state) => {
    const {
        directory:{
            shorts,
        }={},

        service:{
            Directory:{
                loadShortDirectory,
            }={},

        }={}
    } = state;
    return {
        shorts,
        loadShortDirectory,
    }
}

export default mapStateToProps;